<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">State</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <vs-checkbox v-model="checkBox1">Primary - active</vs-checkbox>
              </li>
              <li>
                <vs-checkbox v-model="checkBox2"
                  >Primary - inactive</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox disabled="true" v-model="checkBox3"
                  >Primary - active - disabled</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox disabled="true" v-model="checkBox4"
                  >Primary - inactive - disabled</vs-checkbox
                >
              </li>
            </ul>
          </div>
        </div>
      </vs-col>

      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Color</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <vs-checkbox v-model="ccheckBox1">Primary</vs-checkbox>
              </li>
              <li>
                <vs-checkbox color="success" v-model="ccheckBox2"
                  >Success</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox color="danger" v-model="ccheckBox3"
                  >Danger</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox color="warning" v-model="ccheckBox4"
                  >Warning</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox color="dark" v-model="ccheckBox5"
                  >Dark</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox color="rgb(38, 187, 174)" v-model="ccheckBox6"
                  >Color RGB</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox color="#720ea8" v-model="ccheckBox7"
                  >Color HEX</vs-checkbox
                >
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Change Icon</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <ul class="con-s list-none list-inline">
              <li>
                <vs-checkbox v-model="icheckBox1">Primary</vs-checkbox>
              </li>
              <li>
                <vs-checkbox icon="sms" color="success" v-model="icheckBox2"
                  >SMS</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox icon="close" color="danger" v-model="icheckBox3"
                  >Cancel</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox
                  icon="attach_file"
                  color="warning"
                  v-model="icheckBox4"
                  >File</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox
                  icon="format_bold"
                  color="dark"
                  v-model="icheckBox5"
                  >Bold</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox
                  icon="location_searching"
                  color="rgb(38, 187, 174)"
                  v-model="icheckBox6"
                  >Location</vs-checkbox
                >
              </li>
              <li>
                <vs-checkbox
                  icon="camera_alt"
                  color="#720ea8"
                  v-model="icheckBox7"
                  >Camera</vs-checkbox
                >
              </li>
            </ul>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: function () {
    return {
      checkBox1: true,
      checkBox2: false,
      checkBox3: true,
      checkBox4: false,
      ccheckBox1: true,
      ccheckBox2: true,
      ccheckBox3: true,
      ccheckBox4: true,
      ccheckBox5: true,
      ccheckBox6: true,
      ccheckBox7: true,
      icheckBox1: true,
      icheckBox2: true,
      icheckBox3: true,
      icheckBox4: true,
      icheckBox5: true,
      icheckBox6: true,
      icheckBox7: true,
    };
  },
};
</script>